'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// constants for seasons
var SUMMER = 0;
var AUTUMN = 1;
var WINTER = 2;
var SPRING = 3;

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2Res9 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Res9, _Component);

  function Module2Res9() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Res9);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Res9.__proto__ || (0, _getPrototypeOf2.default)(Module2Res9)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Ideas for healthy snacks',
      summer: {
        season: 'Summer',
        from: 'December',
        to: 'February',
        fruits: ['Apricot', 'Bananas', 'Berries', 'Cherries', 'Grapes', 'Mangoes', 'Nectarines', 'Passionfruit', 'Peaches', 'Pineapple', 'Plums', 'Rockmelon', 'Watermelon'],
        vegetables: ['Beans', 'Corn', 'Celery', 'Cucumber', 'Lettuce', 'Mushrooms', 'Peas', 'Potatoes', 'Pumpkin', 'Squash', 'Tomatoes', 'Zucchini', '']
      },
      autumn: {
        season: 'Autumn',
        from: 'March',
        to: 'May',
        fruits: ['Apples', 'Bananas', 'Passionfruit', 'Pears', 'Rockmelon', '', '', '', '', '', '', ''],
        vegetables: ['Broccoli', 'Cauliflower', 'Celery', 'Lettuce', 'Mushrooms', 'Peas', 'Potatoes', 'Pumpkin', 'Spinach or silverbeet', 'Squash', 'Tomatoes', 'Zucchini']
      },
      winter: {
        season: 'Winter',
        from: 'June',
        to: 'August',
        fruits: ['Apples', 'Kiwifruit', 'Lemons & Limes', 'Mandarins', 'Oranges', '', '', '', '', '', '', '', '', ''],
        vegetables: ['Broccoli', 'Carrots', 'Cauliflower', 'Celery', 'Eggplant', 'Lettuce', 'Mushrooms', 'Onion', 'Peas', 'Potatoes', 'Pumpkin', 'Squash', 'Tomatoes', 'Zucchini']
      },
      spring: {
        season: 'Spring',
        from: 'September',
        to: 'November',
        fruits: ['Berries', 'Kiwifruit', '', '', '', '', '', '', '', '', ''],
        vegetables: ['Asparagus', 'Celery', 'Lettuce', 'Mushrooms', 'Peas', 'Potatoes', 'Pumpkin', 'Spinach or silverbeet', 'Squash', 'Tomatoes', 'Zucchini']
      }
    }, _this.renderSeasonalTable = function (season) {
      var obj = {};
      var count = 0;
      if (season === SUMMER) {
        obj = _this.state.summer;
      } else if (season === AUTUMN) {
        obj = _this.state.autumn;
      } else if (season === WINTER) {
        obj = _this.state.winter;
      } else if (season === SPRING) {
        obj = _this.state.spring;
      }

      // can't use JSX, because it needs to be HTML
      // also couldn't put div inside a table's tbody, so made div encapsulate the ENTIRE table from the outside
      // instead
      var renderHTML = '<table class="table table-bordered table-striped"><thead><tr><th>Fruits</th><th>Vegetables</th></tr></thead><tbody>';
      for (count = 0; count < obj.fruits.length; count++) {
        renderHTML += '<tr><td>' + obj.fruits[count] + '</td><td>' + obj.vegetables[count] + '</td></tr>';
      }
      renderHTML += '</tbody></table>';
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h4',
          null,
          obj.season
        ),
        _react2.default.createElement(
          'h5',
          null,
          obj.from,
          ' to ',
          obj.to
        ),
        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: renderHTML } })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module2Res9, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, xs: 12, sm: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 2'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                'h2',
                null,
                'Seasonal guide to fruit and vegetables'
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12 },
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 6 },
                  this.renderSeasonalTable(SUMMER)
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 6 },
                  this.renderSeasonalTable(AUTUMN)
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12 },
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 6 },
                  this.renderSeasonalTable(WINTER)
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 6 },
                  this.renderSeasonalTable(SPRING)
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module2Res9;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Res9;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/2/Res9.js
// module id = 1246
// module chunks = 0